import React from 'react';

import {processDetailsURL} from 'processes/dao/ProcessManagementDAO';
import {
  createDirectFileOpenClickHandler,
  getSharedSmartChipProps,
  SharedSmartChipProps,
} from 'ui-library/chips/ChipUtil';
import {apiIdToIconName} from 'util/APIUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export default function ProcessChip(props: SharedSmartChipProps<SmartChipType.PROCESS>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: process,
    handleClickLink,
    isInaccessible,
    itemUrl: processUrl,
  } = useSmartChipQuery<SmartChipType.PROCESS>({
    id,
    onClick,
    getUrlFn: ({id}) => processDetailsURL(id),
  });

  const onClickHandler = createDirectFileOpenClickHandler(process, onClick, handleClickLink);

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={process != null ? apiIdToIconName(process.id) : null}
      isInaccessible={isInaccessible}
      item={process}
      onClick={onClickHandler}
      url={processUrl}
    />
  );
}
